module.exports = __webpack_public_path__ + "static/media/kid.f408fc17.png";